export const DADATA_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fio';
